import React, { memo } from 'react';
import PropTypes from 'prop-types';

const DocumentsTableMobile = ({ documents }) => {
  return (
    <div className="cases-table-mobile">
      {documents.map((document) => {
        return (
          <div key={document.id} className="case-mobile-row">
            <div className="d-flex space-between m-t-sm">
              <div className="m-r-md flex-1">{document.name}</div>
            </div>
            <div className="d-flex space-between m-t-sm">
              <div className="secondary">
                {document.description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

DocumentsTableMobile.propTypes = {
  documents: PropTypes.array,
};

export default memo(DocumentsTableMobile);
